import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

import useSchedule from "../../hooks/useShedule";

import CustomButton from "../../Components/CustomButton";
import ModalWarning from "../../Components/ModalWarning";
import OnetimeFlow from "../../Components/CreateSchedule/OnetimeFlow";
import IndividualFlow from "../../Components/CreateSchedule/IndividualFlow";
import GroupFlow from "../../Components/CreateSchedule/GroupFlow";
import ProgressCircle from "../../Components/ProgressCircle";
import BackButton from "../../Components/BackButton";
import Loader from "../../Components/Loader";
import {
  scheduleTypes,
  getProgresBarTitles,
} from "../../Components/CreateSchedule/constants";

import { ReactComponent as Tick } from "../../static/images/tick_sign.svg";

import "./style.scss";

const CreateSchedule = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    currentStep,
    totalSteps,
    selectedScheduleType,
    formData,
    formDataChanged,
    currency,
    invitedCustomers,
    selectedDayAndTime,
    errors,
    loading,
    maxMembersHasError,
    warningModalToggle,
    setWarningModalToggle,
    handleBack,
    handleNext,
    handleSelectDay,
    handleInviteCustomer,
    handleDeleteCustomer,
    setInviteInputValue,
    handleFormFieldChange,
    editSchedule,
  } = useSchedule();

  const progresBarTitles = getProgresBarTitles(t);

  const progresBarTitleKey =
    selectedScheduleType === scheduleTypes.oneTime ? "oneTime" : "group";

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (currentStep !== totalSteps) return;

    editSchedule();
  };

  return (
    <div className="edit-schedule-container">
      {loading && <Loader />}
      <ModalWarning
        warningText={t("createSchedule.schedule_created_success")}
        buttonText={t("go_main_page")}
        changeModal={setWarningModalToggle}
        modalValue={warningModalToggle}
        Image={Tick}
        handleButton={() => {
          localStorage.setItem("requestNotificationPermissionProvider", true);
          window.dispatchEvent(new Event("localStorageChangedNotifications"));
          navigate("/sessions");
        }}
      />
      <div className="progress-fixed-container">
        <div className="progress-bar">
          <ProgressCircle
            totalSteps={totalSteps - 2}
            currentStep={
              currentStep === totalSteps ? currentStep - 2 : currentStep - 1
            }
          />
          <div className="labels">
            <h2>
              {progresBarTitles[`step${currentStep}`][progresBarTitleKey].title}
            </h2>
            <p>
              {
                progresBarTitles[`step${currentStep}`][progresBarTitleKey]
                  .subTitle
              }
            </p>
          </div>
        </div>
      </div>
      <form onSubmit={handleFormSubmit}>
        <>
          <div>
            {selectedScheduleType === scheduleTypes.oneTime && (
              <OnetimeFlow
                currentStep={currentStep}
                formData={formData}
                invitedCustomers={invitedCustomers}
                errors={errors}
                currency={currency}
                setInviteInputValue={setInviteInputValue}
                inviteCutomer={handleInviteCustomer}
                deleteCustomer={handleDeleteCustomer}
                handleFormFieldChange={handleFormFieldChange}
              />
            )}
            {selectedScheduleType === scheduleTypes.individual && (
              <IndividualFlow
                currentStep={currentStep}
                formData={formData}
                invitedCustomers={invitedCustomers}
                selectedDayAndTime={selectedDayAndTime}
                errors={errors}
                currency={currency}
                setInviteInputValue={setInviteInputValue}
                inviteCutomer={handleInviteCustomer}
                deleteCustomer={handleDeleteCustomer}
                handleFormFieldChange={handleFormFieldChange}
                setSelectedDayAndTime={handleSelectDay}
              />
            )}
            {selectedScheduleType === scheduleTypes.group && (
              <GroupFlow
                currentStep={currentStep}
                formData={formData}
                invitedCustomers={invitedCustomers}
                selectedDayAndTime={selectedDayAndTime}
                errors={errors}
                currency={currency}
                maxMembersHasError={maxMembersHasError}
                setInviteInputValue={setInviteInputValue}
                inviteCutomer={handleInviteCustomer}
                deleteCustomer={handleDeleteCustomer}
                handleFormFieldChange={handleFormFieldChange}
                setSelectedDayAndTime={handleSelectDay}
              />
            )}
          </div>

          <div className="edit-shcedule-fixed-container">
            <div className="edit-schedule-buttons-wrapper">
              <BackButton
                onClick={handleBack}
                onModalConfirm={() => navigate("/schedules")}
                showDataLoseWarning={formDataChanged && currentStep === 2}
              />
              {currentStep > 1 && currentStep < totalSteps && (
                <CustomButton onClick={handleNext}>
                  {currentStep !== totalSteps - 1
                    ? t("next")
                    : t(
                        invitedCustomers.length === 0
                          ? "skip_and_review"
                          : "review",
                      )}
                </CustomButton>
              )}
              {currentStep === totalSteps && (
                <CustomButton type="submit" disabled={!formDataChanged}>
                  {t("confirm")}
                </CustomButton>
              )}
            </div>
          </div>
        </>
      </form>
    </div>
  );
};

export default CreateSchedule;
